var _title, _desc, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgIconWarning = function SvgIconWarning(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16"
  }, props), _title || (_title = /*#__PURE__*/React.createElement("title", null, "Group 9")), _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Portal-App",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Dashboard-Weekly",
    transform: "translate(-194.000000, -294.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(15.500000, 217.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-7",
    transform: "translate(1.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-9",
    transform: "translate(177.500000, 77.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    x: 0,
    y: 0,
    width: 16,
    height: 16,
    rx: 8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.5,2 L9.5,2 L9.5,10 L6.5,10 L6.5,2 Z M6.5,12.4819277 C6.5,12.0602389 6.64583187,11.7078327 6.9375,11.4246988 C7.22916812,11.1415648 7.58333125,11 8,11 C8.41666875,11 8.77083188,11.1415648 9.0625,11.4246988 C9.35416813,11.7078327 9.5,12.0602389 9.5,12.4819277 C9.5,12.9036166 9.35416813,13.2620467 9.0625,13.5572289 C8.77083188,13.8524111 8.41666875,14 8,14 C7.58333125,14 7.22916812,13.8524111 6.9375,13.5572289 C6.64583187,13.2620467 6.5,12.9036166 6.5,12.4819277 Z",
    id: "\\uEA95",
    fill: "#FF6B00",
    fillRule: "nonzero"
  }))))))));
};

export default __webpack_public_path__ + "static/media/icon-warning.911c4397.svg";
export { SvgIconWarning as ReactComponent };